import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.listing
 * @constructor
 */
export class ListingModel extends BaseModel {
  /**
   * @param {string} id
   * @param {string} title
   * @param {string} description
   * @param {loavies.models.base.PriceModel} price
   * @param {loavies.models.image.ImageModel[]} [images]
   * @param {loavies.models.listing.ListingPrivateDataModel} [privateData]
   * @param {loavies.models.listing.ListingPublicDataModel} [publicData]
   * @param {string} [state]
   * @param {Date} createdAt
   * @param {loavies.models.user.UserModel} [author]
   * @param {loavies.models.listing.ListingStockModel} [stock]
   */
  constructor({
    id,
    title,
    description,
    price,
    images,
    privateData,
    publicData,
    state,
    createdAt,
    author,
    stock,
  }) {
    super()

    /** @type {string} */
    this.id = id

    /** @type {string} */
    this.title = title

    /** @type {string} */
    this.description = description

    /** @type {loavies.models.base.PriceModel} */
    this.price = price

    /** @type {loavies.models.image.ImageModel[]|undefined} */
    this.images = images

    /** @type {loavies.models.listing.ListingPrivateDataModel|undefined} */
    this.privateData = privateData

    /** @type {loavies.models.listing.ListingPublicDataModel} */
    this.publicData = publicData

    /** @type {string} */
    this.state = state

    /** @type {Date} */
    this.createdAt = createdAt

    /** @type {loavies.models.user.UserModel} */
    this.author = author

    /** @type {loavies.models.listing.ListingStockModel} */
    this.stock = stock
  }
}

export const LISTING_CONDITIONS = {
  NEW_WITH_PRICE_TAG: 'new_with_price_tag',
  NEW_WITHOUT_PRICE_TAG: 'new_without_price_tag',
  VERY_GOOD: 'very_good',
  GOOD: 'good',
  USED: 'used',
}

export const LISTING_STATES = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
  PENDING_APPROVAL: 'pendingApproval',
  CLOSED: 'closed',
}
